import { Component, OnInit, OnChanges, SimpleChanges, Output, Input, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MapUnits } from './map-units.config';
import { MapService } from '../../services/map/map.service';
import { Layer } from '../../models/layer.model';
import { Thematic } from '../../models/thematic.model';
import * as ol from 'openlayers';
import { HighlightingFeaturesService } from 'app/services/map/highlighting_features';
import { TranslateService } from '@ngx-translate/core';
declare var $;//jquery
declare var proj4: any; // proj4

const GETFEATUREINFO_IMAGE_SIZE_DEFAULT = [101, 101];
const HEADER_SIZE = 55;
@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.css'],
})

export class MapComponent implements OnInit, OnChanges {

    //--- Events de OUTPUT (es deriva a GisWeb i ell fa el tractament oportu)
    @Output() private processLayers = new EventEmitter<Object>();
    @Output() private openFeatureInfo = new EventEmitter<Object>();
    @Output() private escalaActual = new EventEmitter<Object>();
    @Output() private downloadCompleted = new EventEmitter<String>();

    //--- Paràmetres de INPUT rebuts del GisWeb.

    //S'ha fet un canvi a la toc: toggle de les capes de l'arbre.
    @Input() layerChanged: Layer[];
    //Esborrar temàtic del mapa
    @Input() thematicToRemove: Thematic;
    //Afegir un nou temàtic al mapa
    @Input() thematicToAdd: Thematic;
    //Afegir marcador al mapa
    @Input() markerPoi: Object;
    //Afegir Eina (layer)
    @Input() toolAdded = {};
    //Afegir interacció
    @Input() interactionAdded = {};
    //Esborrar interacció
    @Input() interactionRemoved = {};
    //Toggle vista previa d'impressió
    @Input() createPrintPreviewMap: any;
    //Imprimeix el mapa
    @Input() callPrintMap: any;

    // mapa de l'aplicació
    public map: ol.Map;
    // mapa preview
    public previewMap: ol.Map;
    //paràmetres entrats via URL
    private queryParams;
    private centerQueryParam: any;
    private thematicQueryParam: any;
    private scaleQueryParam: any;
    private markerQueryParam: any;
    private scaleToShowInfo: any;

    // capes
    public printLayer: ol.layer.Vector = null;
    private markerLayers: any;
    private toolLayersAdded: ol.layer.Vector[] = [];
    private visibleLayers = []; //Capes activades amb el temàtic (this.actualThematic) seleccionat

    //Missatges a mostrar al mapa
    private mapIssues: Object[] = [];

    //Gestió de classes CSS i estils
    private geolocationClasses = {
        geolocation: true,
        geolocationActive: false
    };

    private mapDiv: any;
    private headerDiv: any;

    //Configuració del mapa rebuda amb el MapService.
    private static config: any;

    //Controls: temàtic seleccionat actualment
    private actualThematic: string;
    public sourceThematic: string;
    //Controls: Interaccions afegides al mapa
    private interactionsAdded: ol.interaction.Interaction[] = [];
    //Controls: Eina de geoposició.
    private geolocation: ol.Geolocation;
    private translateParams: {
        scale: number
    }
    private printPreviewParams = null;
    constructor(
        // Serveix les peticions HTTP relacionades amb el Mapa
        private MapService: MapService,
        /*ActivatedRoute, Router i Location: els fem servir per poder accedir als query params i poder-los actualitzar de forma dinàmica*/
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private hlLayersService: HighlightingFeaturesService,
        private translateService: TranslateService
    ) {
        this.defineProjections();
        this.queryParams = this.route
            .queryParams
            .subscribe(params => {
                this.centerQueryParam = params['center'];
                this.thematicQueryParam = params['thematic'];
                this.scaleQueryParam = params['scale'];
                this.markerQueryParam = params['marker'];
            });
        this.translateParams = {
            scale: this.scaleQueryParam
        };
    }

    ngOnInit() {
        console.debug(">>> MapComponent: ngOnInit");
        try {
            this.MapService.getFeatureInfoConfig().then(data => { console.debug("Configuració de la featureInfo recuperada correctament.") });
            MapComponent.config = this.MapService.getConfigurationFromUrl().then(data => {
                MapComponent.config = data;
                this.scaleToShowInfo = MapComponent.config.mapconfig.minScaleToShowInfo ? MapComponent.config.mapconfig.minScaleToShowInfo : 1000;
                //console.debug("MapComponent.config >> ", MapComponent.config);
                //map projection
                let projection = ol.proj.get(MapComponent.config.mapconfig.srs);
                //map extent assigned to projection
                projection.setExtent([
                    MapComponent.config.mapconfig.bbox[0], MapComponent.config.mapconfig.bbox[1],//xmin ymin
                    MapComponent.config.mapconfig.bbox[2], MapComponent.config.mapconfig.bbox[3] //xmax ymax
                ]);

                let resolutions = this.getResolutions();
                let centerAttr: [number, number] = [
                    (MapComponent.config.mapconfig.bbox[2] + MapComponent.config.mapconfig.bbox[0]) / 2,
                    (MapComponent.config.mapconfig.bbox[3] + MapComponent.config.mapconfig.bbox[1]) / 2
                ];

                let resolution = resolutions[0];

                //Map initialitzation
                this.map = new ol.Map({
                    target: 'map',//div id
                    layers: [],
                    controls: ol.control.defaults({ attribution: false, rotate: false, zoom: false }),
                    view: new ol.View({
                        projection: projection,
                        resolutions: resolutions,
                        extent: [
                            MapComponent.config.mapconfig.bbox[0], MapComponent.config.mapconfig.bbox[1],//xmin ymin
                            MapComponent.config.mapconfig.bbox[2], MapComponent.config.mapconfig.bbox[3] //xmax ymax
                        ]
                    })
                });

                //Si han especificat l'escala per paràmetre, l'agafem d'allà.
                if (typeof (this.scaleQueryParam) !== "undefined") {
                    let scale = Number(this.scaleQueryParam);
                    this.translateParams = {
                        scale: scale
                    }
                    resolution = this.getResolutionFromScale(scale, "m");
                    this.map.getView().setResolution(resolution);
                }
                else {
                    console.debug("No scale param specified: need to fit initial extent");
                    this.map.getView().fit([
                        MapComponent.config.mapconfig.bbox[0], MapComponent.config.mapconfig.bbox[1],//xmin ymin
                        MapComponent.config.mapconfig.bbox[2], MapComponent.config.mapconfig.bbox[3] //xmax ymax
                    ],{
                       size:this.map.getSize()
                    });
                }

                //Si han especificat l'escala per paràmetre, l'agafem d'allà.
                if (typeof (this.centerQueryParam) !== "undefined") {
                    let scale = Number(this.scaleQueryParam);
                    this.translateParams = {
                        scale: scale
                    }
                    resolution = this.getResolutionFromScale(scale, "m");
                    this.map.getView().setResolution(resolution);
                }

                //Si han especificat el centre per paràmetre, l'agafem d'allà.
                if (typeof (this.centerQueryParam) !== "undefined") {
                    centerAttr = [Number(this.centerQueryParam.split(",")[0]), Number(this.centerQueryParam.split(",")[1])];
                    this.map.getView().setCenter(centerAttr);
                }

                this.MapService.parseLayers(MapComponent.config.layers);
                this.MapService.parseServices(MapComponent.config.services);
                this.MapService.parseThematics(MapComponent.config.thematic);
                this.MapService.parseLinks(MapComponent.config.links);
                let position = 0;
                let elements = this.MapService.getThematics();

                //Si han especificat un temàtic per paràmetre, l'agafem d'allà.
                if (typeof (this.thematicQueryParam) !== "undefined") {
                    for (let i = 0; i < elements.length; i++) {
                        if (elements[i].id === this.thematicQueryParam) {
                            position = i;
                            break;
                        }
                    }
                }

                let sourceMarkerLayers = new ol.source.Vector();
                this.markerLayers = new ol.layer.Vector({
                    source: sourceMarkerLayers,
                    style: [new ol.style.Style({
                        image: new ol.style.Icon({
                            src: "assets/img/marker-icon2.png",
                            scale: 1,
                            anchor: [24, 45], //La imatge quedava uns pixels desplaçada del punt on hem clicat i cal retocar-ho.
                            anchorXUnits: 'pixels',
                            anchorYUnits: 'pixels'
                        })
                    })
                    ]
                });

                let properties = {
                    id: "olMarkers",
                    name: "olMarkers",
                    zIndex: 1000,
                    isTool: true
                };

                this.markerLayers.setProperties(properties, true);
                this.toolLayersAdded.push(this.markerLayers);

                this.addThematic(elements[position]);
                this.map.addLayer(this.markerLayers);

                /*Afegim marcador al carregar la pàgina si existeix un centre i si markerQueryParam és cert */
                if(this.centerQueryParam !== undefined && this.markerQueryParam === "true"){
                   this.addMarkerOnInit();
                }

                let onMoveEndMap = (event) => {
                    let xmin = Number(MapComponent.config.mapconfig.bbox[0]);
                    let ymin = Number(MapComponent.config.mapconfig.bbox[1]);
                    let xmax = Number(MapComponent.config.mapconfig.bbox[2]);
                    let ymax = Number(MapComponent.config.mapconfig.bbox[3]);

                    let map = event.map ? event.map : this.map;
                    let center = [map.getView().getCenter()[0].toFixed(1), map.getView().getCenter()[1].toFixed(1)];
                    /*  let invalidCenter = Number(center[0]) < xmin || Number(center[0]) > xmax || Number(center[1]) < ymin || Number(center[1]) > ymax;
                      console.debug("center:", center);
                      console.debug("init extent:", MapComponent.config.mapconfig.bbox);
                      console.debug("Is a Valid Center?", invalidCenter ? "Nop!" : "Yep!");

                      if (invalidCenter) {
                          center = [
                              (xmax + xmin) / 2,
                              (ymax + ymin) / 2
                          ];
                          event.map.getView().setCenter(center);
                      }*/

                    let scale = Math.round(this.getScaleFromResolution(map.getView().getResolution(), "m"));
                    this.escalaActual.emit(scale);
                    this.translateParams = {
                        scale: scale
                    }

                    if (this.printLayer !== null) {
                        this.destroyPrintPreviewMap();
                        this.printPreviewParams.config.scale = scale;
                        this.togglePrintPreview(this.printPreviewParams);
                    }

                    if(this.markerQueryParam !== undefined){
                        this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic + "&marker=" + this.markerQueryParam);
                        this.MapService.setUrl(window.location.origin + window.location.pathname + "?center=" + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic + "&marker=" + this.markerQueryParam);
                    }
                    else{
                        this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic);
                        this.MapService.setUrl(window.location.origin + window.location.pathname + "?center=" + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic);    
                    }                   
                };

                let singleClickMap = (event) => {
                    if (this.interactionsAdded.length === 0) {
                        this.removeMarkers();
                        if(this.markerQueryParam !== undefined)
                            this.markerQueryParam = true;
                        /* Afegim marcador al mapa*/
                        let feature = this.addMarker({ id: 'getFeatureInfoClick', x: event.coordinate[0], y: event.coordinate[1] });
                        /* Centra el mapa en el marcador */
                        this.map.getView().setCenter(event.coordinate);
                        /*
                          Fa servir el mateix procediment que el getFeatureInfo natiu de openlayers,
                          però ens estalviem que ho maqueti amb una URL. Si volem URL, ja ho farem nosaltres.
                         */
                        let bbox = this.getFeatureInfoExtent(event.coordinate);
                        let resolution = this.getMap().getView().getResolution();
                        /*
                          Necessitem recalcular els PIXELS per ajustar-los al bbox calculat de forma correcta.
                          De nou, segueix el mateix procediment que el getFeatureInfo natiu de openlayers.
                        */
                        let x = Math.floor((event.coordinate[0] - bbox[0]) / resolution);
                        let y = Math.floor((bbox[3] - event.coordinate[1]) / resolution);
                        const srsProjection = this.map.getView().getProjection().getCode();
                        this.MapService.getPreviewInfoFromPoint(srsProjection, bbox, [x, y], event.coordinate).then(data => {
                            if (this.getScaleFromResolution(this.map.getView().getResolution(), "m") <= this.scaleToShowInfo && typeof (data.features) !== "undefined" && data.features.length > 0) {
                                data.coordinates = [event.coordinate[0].toFixed(1), event.coordinate[1].toFixed(1)];
                                data.srs = srsProjection;
                                data.message = "";
                            } else {
                                this.translateService.get('Escala allunyada').subscribe((traduccio_realitzada_titol: string) => {
                                    data.message = traduccio_realitzada_titol
                                });
                            }
                            this.escalaActual.emit(Math.round(this.getScaleFromResolution(this.map.getView().getResolution(), "m")));
                            this.openFeatureInfo.emit(data);
                        });
                    }
                }

                this.map.on('moveend', onMoveEndMap);
                this.map.on('click', singleClickMap);
            });
        }
        catch (Exception) {
            console.error("No hem pogut recuperar la configuracio");
            this.mapIssues.push({ message: "No hem pogut recuperar la configuracio" });
        }

    }
    /**
    * Les variables definides com a @Input disparen l'event de change si pateixen un canvi d'algún tipus.
    */
    ngOnChanges(changes: SimpleChanges) {
        console.debug(">>> MapComponent: ngOnChanges");
        try {
            if (typeof (changes.layerChanged) !== "undefined" && changes.layerChanged.currentValue.length > 0) {
                this.toggleLayers(changes.layerChanged.currentValue);
            }
            if (typeof (changes.thematicToRemove) !== "undefined" && typeof (changes.thematicToRemove.currentValue.id) !== "undefined" && changes.thematicToRemove.currentValue.id.length > 0) {
                this.removeThematic(changes.thematicToRemove.currentValue);
            }
            if (typeof (changes.thematicToAdd) !== "undefined" && changes.thematicToAdd.currentValue.id != undefined && changes.thematicToAdd.currentValue.id.length > 0) {
                this.addThematic(changes.thematicToAdd.currentValue);
            }
            if (typeof (changes.toolAdded) !== "undefined" && changes.toolAdded.currentValue !== undefined) {
                this.addToolLayer(changes.toolAdded.currentValue);
            }
            if (typeof (changes.interactionAdded) !== "undefined" && changes.interactionAdded.currentValue !== undefined && changes.interactionAdded.currentValue.getProperties().active) {
                this.addInteraction(changes.interactionAdded.currentValue);
            }
            if (typeof (changes.interactionRemoved) !== "undefined" && changes.interactionRemoved.currentValue) {
                this.removeInteraction(changes.interactionRemoved.currentValue);
            }

            if (typeof (changes.createPrintPreviewMap) !== "undefined" && changes.createPrintPreviewMap.currentValue && changes.createPrintPreviewMap.currentValue.state === "true") {
                this.togglePrintPreview(changes.createPrintPreviewMap.currentValue);
            }

            if (typeof (changes.callPrintMap) !== "undefined" && changes.callPrintMap.currentValue && changes.callPrintMap.currentValue.state === "true") {
                this.printMapHandler(changes.callPrintMap.currentValue);
            }

            if (typeof (changes.markerPoi) !== "undefined" && this.markerLayers && changes.markerPoi.currentValue !== null) {
                console.debug(changes.markerPoi.currentValue);
                this.removeMarkers();
                let feature = this.addMarker(changes.markerPoi.currentValue);
                let extent = feature.getGeometry().getExtent();
                this.centraAmbEfecte(extent);
            }

        }
        catch (e) { console.warn("Ups, hi ha hagut algun problema al ngOnChanges del map.component.ts", e); }
    }

    /**
       * S'executa just després de renderitzar la vista.
       */
    public ngAfterViewInit() {
        console.debug(">>> MapComponent: ngAfterViewInit");
        this.mapDiv = document.getElementById('map');
        this.headerDiv = document.getElementById('header');
        let height = window.innerHeight - HEADER_SIZE + "px";
        this.mapDiv.style.height = height;
        // establir l'amplada del mapa
        this.mapDiv.style.width = window.innerWidth + "px";
        if (this.map) {
            this.map.updateSize();
        }
    }

    /*
    * Escoltem l'event de resize de les finestres, per ajustar el mapa a la vista.
    */
    @HostListener('window:resize', ['$event'])
    public onResize(event) {
        console.debug(">>> MapComponent: onResize");
        // establir l'alçada dels panells i del mapa
        let height = window.innerHeight - HEADER_SIZE + "px";
        this.mapDiv = document.getElementById('map');
        this.mapDiv.style.height = height;
        // establir l'amplada del mapa
        this.mapDiv.style.width = window.innerWidth + "px";

        if (this.map) {
            this.map.updateSize();
        }
    }

    getMap(): any {
        console.debug(">>> MapComponent: getMap");
        return this.map;
    }


    /**
    * Definim les projections per a que l'openlayers sigui capaç de pintar bé les capes
    */
    private defineProjections() {
        console.debug(">>> MapComponent: defineProjections");
        proj4.defs([
            ['EPSG:54004', "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"],
            ['EPSG:23029', '+proj=utm +zone=29 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
            ['EPSG:23031', '+proj=utm +zone=31 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
            ['EPSG:23030', '+proj=utm +zone=30 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
            ['EPSG:4269', '+proj=utm +zone=32 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
            ['EPSG:25829', '+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
            ['EPSG:25830', '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
            ['EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
            ['EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
            ['EPSG:32629', '+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs'],
            ['EPSG:32630', '+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs'],
            ['EPSG:32631', '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs'],
            ['EPSG:32632', '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs'],
            ['EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs'],
            ['EPSG:4230', '+proj=longlat +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +no_defs'],
            ['EPSG:4258', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs']
        ]);

    }

    /**
     * Afegim Marker al carregar la pàgina
     */
    private addMarkerOnInit(): void {
        let centerAttr: [number, number] = [
            (MapComponent.config.mapconfig.bbox[2] + MapComponent.config.mapconfig.bbox[0]) / 2,
            (MapComponent.config.mapconfig.bbox[3] + MapComponent.config.mapconfig.bbox[1]) / 2
        ];
        centerAttr = [Number(this.centerQueryParam.split(",")[0]), Number(this.centerQueryParam.split(",")[1])];
        let feature = this.addMarker({ id: 'getFeatureInfoClick', x: centerAttr[0], y: centerAttr[1] });
        /* Centra el mapa en el marcador */
        this.map.getView().setCenter(centerAttr);
        /*
            Fa servir el mateix procediment que el getFeatureInfo natiu de openlayers,
            però ens estalviem que ho maqueti amb una URL. Si volem URL, ja ho farem nosaltres.
            */
        let bbox = this.getFeatureInfoExtent(centerAttr);
        let resolution = this.getMap().getView().getResolution();
        /*
            Necessitem recalcular els PIXELS per ajustar-los al bbox calculat de forma correcta.
            De nou, segueix el mateix procediment que el getFeatureInfo natiu de openlayers.
        */
        let x = Math.floor((centerAttr[0] - bbox[0]) / resolution);
        let y = Math.floor((bbox[3] - centerAttr[1]) / resolution);
        const srsProjection = this.map.getView().getProjection().getCode();
        this.MapService.getPreviewInfoFromPoint(srsProjection,bbox, [x, y], centerAttr).then(data => {
            if (this.getScaleFromResolution(this.map.getView().getResolution(), "m") <= this.scaleToShowInfo && typeof (data.features) !== "undefined" && data.features.length > 0) {
                data.coordinates = [centerAttr[0].toFixed(1), centerAttr[1].toFixed(1)];
                data.srs = srsProjection;
                data.message = "";
            } else {
                this.translateService.get('Escala allunyada').subscribe((traduccio_realitzada_titol: string) => {
                    data.message = traduccio_realitzada_titol
                });
            }
            this.openFeatureInfo.emit(data);

        });

    }

    /**
    * Esborra un Thematic.
    */
    private removeThematic(thematic: Thematic): void {
        console.debug(">>> MapComponent: removeThematic");

        for (let i = 0; i < this.visibleLayers.length; i++) {
            let layer = this.visibleLayers[i];
            this.map.removeLayer(layer);
        }

        this.visibleLayers = [];

        let layers = this.MapService.getLayers();
        for (let i = 0; i < layers.length; i++) {
            let id = layers[i].id;
            if (thematic.layersId.indexOf(id) >= 0) {
                layers[i].active = false;
            }
        }

        this.actualThematic = "";

        let center = [this.map.getView().getCenter()[0].toFixed(1), this.map.getView().getCenter()[1].toFixed(1)];
        let scale = Math.round(this.getScaleFromResolution(this.map.getView().getResolution(), "m"));
        this.escalaActual.emit(scale);
        if(this.markerQueryParam !== undefined)
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&marker=" + this.markerQueryParam);
        else
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale);
    }

    /**
    * Afegeix un Thematic.
    */
    private addThematic(thematic: Thematic): void {
        console.debug(">>> MapComponent: addThematic");


        let layers = Array<Layer>();

        if (thematic.layers.length == 0) {
            for (let i = 0; i < thematic.layersId.length; i++) {
                let layer = this.MapService.getLayersBy("id", thematic.layersId[i]);
                if (layer.length > 0) {
                    layers.push(layer[0]);
                }
            }
            thematic.layers = layers;
        }

        for (let i = 0; i < thematic.layers.length; i++) {
            this.addLayerToMap(thematic.layers[i], true);
        }

        this.actualThematic = thematic.id;
        this.sourceThematic = thematic.source;
        let center = [this.map.getView().getCenter()[0].toFixed(1), this.map.getView().getCenter()[1].toFixed(1)];
        let scale = Math.round(this.getScaleFromResolution(this.map.getView().getResolution(), "m"));
        this.escalaActual.emit(scale);
        if(this.markerQueryParam !== undefined){
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic + "&marker=" + this.markerQueryParam);
        }
        else
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic);
        
    }

    private addToolLayer(layer): void {
        console.debug(">>> MapComponent: addToolLayer");
        if (layer && this.getLayerByProperty("id", layer.get("id")).length > 0)  {
            this.map.removeLayer(this.getLayerByProperty("id", layer.get("id"))[0]);
            let id = layer.get("id");
            for (let i = 0; i < this.toolLayersAdded.length; i++) {
                let tmpLayer = this.toolLayersAdded[i];
                if (tmpLayer.get("id") === id) {
                    this.toolLayersAdded.splice(i, 1);
                }
            }
        }
        if (layer.get("isTool")) {
            this.toolLayersAdded.push(layer);
        }

        this.map.addLayer(layer);
    }

    /**
    * Afegeix una interacció.
    */
    private addInteraction(interaction): void {
        console.debug(">>> MapComponent: addInteraction");
        this.interactionsAdded.push(interaction);
        this.map.addInteraction(interaction);
    }

    /*
    * Esborra una interacció afegida al mapa previament.
    */
    private removeInteraction(interaction: string | ol.interaction.Interaction): void {
        let interactionToRemove;
        console.debug(">>> Map.Component - removeInteraction: gisweb ordered by to remove an interaction");
        let id = (typeof (interaction) === "string") ? interaction : interaction.get("idInteraction");
        for (let i = 0; i < this.interactionsAdded.length; i++) {
            let tmpInteraction: ol.interaction.Interaction = this.interactionsAdded[i];
            if (tmpInteraction.get("idInteraction") === id) {
                this.interactionsAdded.splice(i, 1);
                interactionToRemove = tmpInteraction;
            }
        }
        if(interactionToRemove == undefined) return;

        this.map.removeInteraction(interactionToRemove);
        console.debug(">>> Map.Component - removeInteraction: so interaction removed");
    }

    /**
    * Afegeix una capa al mapa, de tipus tiled o wms.
    */
    private addLayerToMap(layer: Layer, thematic: boolean): void {
        console.debug(">>> Map.Component - addLayerToMap");
        let newBaseLayer;
        let service = this.MapService.getServicesBy("id", layer.serviceId)[0];
        if (typeof (service.tiled) !== "undefined" && service.tiled) {
            newBaseLayer = new ol.layer.Tile({
                opacity: layer.opacity,
                source: new ol.source.TileWMS({
                    url: service.url,
                    projection: MapComponent.config.mapconfig.srs,
                    params: { FORMAT: service.format, VERSION: service.version, SRS: MapComponent.config.mapconfig.srs, LAYERS: layer.name }
                })
            });
        }
        else {
            newBaseLayer = new ol.layer.Image({
                extent: [
                    MapComponent.config.mapconfig.bbox[0], MapComponent.config.mapconfig.bbox[1],//xmin ymin
                    MapComponent.config.mapconfig.bbox[2], MapComponent.config.mapconfig.bbox[3] //xmax ymax
                ],
                opacity: layer.opacity,
                source: new ol.source.ImageWMS({
                    url: service.url,
                    projection: MapComponent.config.mapconfig.srs,
                    params: { FORMAT: service.format, VERSION: service.version, TRANSPARENT: service.transparent, LAYERS: layer.name },
                    ratio: 1
                })
            });
        }

        let properties = {
            id: layer.id,
            name: layer.name,
            zIndex: layer.order,
            title: layer.title,
            isTool: false
        };

        newBaseLayer.setProperties(properties, true);

        this.raiseLayerOrder(newBaseLayer);

        if (thematic) {
            this.visibleLayers.push(newBaseLayer);
        }

    }
    /**
    * Afegir una capa activada des de la toc, al mapa .
    */
    private toggleLayers(layers: Layer[]): void {
        console.debug(">>> Map.Component - toggleLayers");
        for (let index = 0; index < layers.length; index++) {
            let layer = layers[index];
            if (layer.active) {
                layer.active = false;
                this.map.removeLayer(this.getLayerByProperty("id", layer.id)[0]);
            } else {
                layer.active = true;
                this.addLayerToMap(layer, false);
            }
        }
    }
    /**
    * Fem un reset a la capa amb la mateixa ID que la pasada per paràmetre (reset = esborrar tots els features)
    */
    private clearLayer(layerIdArray): void {
        console.debug(">>> Map.Component - clearLayer");
        for (let i = 0; i < layerIdArray.length; i++) {
            let layerId = layerIdArray[i];
            this.getLayerByProperty("id", layerId)[0].getSource().clear();
        }
    }
    /*------------------------------------------------------------------------------------------*/

    /*------------------ MAP MARKERS --------------*/
    private addMarker(object): ol.Feature {
        if(! this.markerLayers) {
            console.warn("No hem pogut afegir el marker, la capa no està preparada");
            return undefined;
        }
        let feature = new ol.Feature(object);
        feature.setId(parseInt(object.id));
        let geometry = null;
        if (object.childs) {
            let portal = object.childs[0];
            geometry = new ol.geom.Point([Number(portal.x), Number(portal.y)], "XY");

        } else {
            geometry = new ol.geom.Point([Number(object.x), Number(object.y)], "XY");

        }
        feature.setGeometry(geometry);
        this.markerLayers.getSource().addFeature(feature);
        console.log("added geometry");

        return feature;
    }

    private removeMarkers(): void {
        if(this.markerLayers) this.markerLayers.getSource().clear();
    }

    private hasFeatures(): boolean {
        for (let index = 0; index < this.toolLayersAdded.length; index++) {
            let layer = this.toolLayersAdded[index];
            if (layer.getSource().getFeatures().length > 0) {
                return true;
            }
        }
        return false;
    }

    private hasInteractions(): boolean {
        return this.interactionsAdded.length > 0;
    }

    private clearAllFeatures(): void {
        for (let index = 0; index < this.toolLayersAdded.length; index++) {
            let layer = this.toolLayersAdded[index];
            layer.getSource().clear();
        }
        this.hlLayersService.removeLayersById(this.map, "hl-layer");
        let center = [this.map.getView().getCenter()[0].toFixed(1), this.map.getView().getCenter()[1].toFixed(1)];
        let scale = Math.round(this.getScaleFromResolution(this.map.getView().getResolution(), "m"));
        this.escalaActual.emit(scale);
        if(this.markerQueryParam !== undefined){
            this.markerQueryParam = false;
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic + "&marker=" + this.markerQueryParam);
        }
        else{
            this.location.go('/?center=' + center.join(",") + "&scale=" + scale + "&thematic=" + this.actualThematic);
        }
            
    }
    private destroyPrintPreviewMap(): void {
        if (this.printLayer !== null) {
            this.removeInteraction("olPrintPreview");
            for (let i = 0; i < this.toolLayersAdded.length; i++) {
                let tmpLayer = this.toolLayersAdded[i];
                if (tmpLayer.get("id") === this.printLayer.get("id")) {
                    this.toolLayersAdded.splice(i, 1);
                }
            }

            this.map.removeLayer(this.printLayer);
            this.printLayer = null;
        }
    }

    private togglePrintPreview(params: any): void {
        this.destroyPrintPreviewMap();
        this.printPreviewParams = params;
        if (params.config.showPreview) {
            let scale = params.config.scale;
            this.escalaActual.emit(scale);
            let resolution = this.getResolutionFromScale(scale, "m");

            let sourcePrintLayers = new ol.source.Vector();
            this.printLayer = new ol.layer.Vector({
                source: sourcePrintLayers,
                style: [new ol.style.Style({
                    fill: new ol.style.Fill({
                        color: 'rgba(255,177,9,0.35)'
                    }),
                    stroke: new ol.style.Stroke({
                        color: "#FFA500",
                        width: 2
                    }),
                    image: new ol.style.Circle({
                        radius: 7,
                        fill: new ol.style.Fill({
                            color: '#ffcc33'
                        })
                    })
                })
                ]
            });

            let properties = {
                id: "olPrintPreview",
                name: "olPrintPreview",
                zIndex: 1000,
                isTool: true
            };

            this.printLayer.setProperties(properties, true);
            this.toolLayersAdded.push(this.printLayer);
            let arrayLayers = this.map.getLayers();

            //Obtenim el centre del mapa
            var centerMap = (typeof (params.config.center) !== "undefined") ? params.config.center : this.map.getView().getCenter();

            var pixWidth = Math.round(params.config.width * MapUnits.INCHES_PER_UNIT.Centimeter * MapUnits.DOTS_PER_INCH);
            var pixHeight = Math.round(params.config.height * MapUnits.INCHES_PER_UNIT.Centimeter * MapUnits.DOTS_PER_INCH);
            if (scale.toString().toLowerCase() === "actual") {
                scale = this.getScaleFromResolution(this.map.getView().getResolution(), 'm');
            }
            else {
                scale = Number(params.config.scale);
            }
            this.printPreviewParams.usedScale = scale;
            //Calculem l'extensió [Xmin, Ymin, Xmax, Ymax] segons el centre
            var extentBox = this.calculateExtentByScale(centerMap, scale, pixWidth, pixHeight);
            var geometryBOX = new ol.geom.Polygon(extentBox, "XY");

            this.map.addLayer(this.printLayer);


            //Creem un feature amb les coordenades.
            var feature = new ol.Feature();

            feature.setGeometry(geometryBOX);
            sourcePrintLayers.addFeature(feature);


            let translate = new ol.interaction.Translate({
                features: new ol.Collection([feature])
            });

            let propertiesInt = {
                idInteraction: "olPrintPreview",
                name: "olPrintPreview",
                isTool: true
            };

            translate.setProperties(propertiesInt);
            this.interactionsAdded.push(translate);
            this.map.addInteraction(translate);

        } else {
            this.printPreviewParams = null;
        }
    }

    private printMapHandler(params: any): void {

        //Obtenim el centre del mapa
        var centerMap = (typeof (params.config.center) !== "undefined") ? params.config.center : this.map.getView().getCenter();

        var pixWidth = Math.round(params.config.width * MapUnits.INCHES_PER_UNIT.Centimeter * MapUnits.DOTS_PER_INCH);
        var pixHeight = Math.round(params.config.height * MapUnits.INCHES_PER_UNIT.Centimeter * MapUnits.DOTS_PER_INCH);

        let width = pixWidth;
        let height = pixHeight;
        //agafem la pasada per paràmetre o bé la actual.
        let scale = (typeof (params.config.scale) !== "undefined") ? params.config.scale : this.getScaleFromResolution(this.map.getView().getResolution(), 'm');
        this.escalaActual.emit(scale);
        if (params.config.scale.toString().toLowerCase() === "actual") {
            scale = this.getScaleFromResolution(this.map.getView().getResolution(), 'm');
            this.escalaActual.emit(scale);
        }
        else {
            scale = Number(params.config.scale);
            this.escalaActual.emit(scale);
        }

        let center = centerMap;
        let extent = [];
        if (this.printLayer) {
            let features = this.printLayer.getSource().getFeatures();
            if (features.length > 0) {
                let previewPolygon = features[0];
                let extentPolygon = previewPolygon.getGeometry().getExtent();
                let xCenter = (extentPolygon[0] + extentPolygon[2]) / 2
                let yCenter = (extentPolygon[1] + extentPolygon[3]) / 2
                center = [xCenter, yCenter];
                extent = this.getExtentFromPointAndScale([xCenter, yCenter], scale, width, height);
            }
            else {
                extent = this.getExtentFromPointAndScale(center, scale, width, height);
            }
        }
        else {
            extent = this.getExtentFromPointAndScale(center, scale, width, height);
        }
        let today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        let day = dd.toString();
        if (dd < 10) {
            day = '0' + dd;
        }
        let month = mm.toString();
        if (mm < 10) {
            month = '0' + mm;
        }
        let todayWellFormatted = day + '/' + month + '/' + yyyy;

        let format: string;
        switch (params.config.format) {
            case "pdf":  format = "JASPER-PDF";  break;
            case "docx": format = "JASPER-DOCX"; break;
            default: format = "JASPER";
        }

        var printParams = {
            formatsize: params.config.size,
            formatorientation: params.config.orientacio,
            formatpages: 1,
            printTarget: "BLANK",
            FORMAT: format,
            date: todayWellFormatted,
            title: params.config.text_titol,
            WIDTH: width,
            HEIGHT: height,
            CENTER: center,
            BACKGROUNDCOLOR: "255,255,255",
            SRS: this.map.getView().getProjection().getCode(),
            SCALE: scale,
            legendUrl: window.location.protocol + "//" + window.location.host + window.location.pathname + "common/dummy.xml",
            isFitxa: false,
            ANGLE: "0",
            XSL: 0,
            XML: window.location.protocol + "//" + window.location.host + window.location.pathname + "common/dummy.xml"
          };

        for (let paramIndex in params.config) {
            if (typeof (printParams[paramIndex.toUpperCase()]) === "undefined") {
                printParams[paramIndex] = params.config[paramIndex];
            }
        }
        let count = 0;
        // creem els parametres de layer(l0,..) estils(s0,...) i transparencia(t0,...)
        var layersArray = this.map.getLayers().getArray();
        for (var i = 0; i < layersArray.length; i++) {

            var layer = layersArray[i]; // layer OL

            if (layer.getVisible()) {

                // evitem layers tipus vector o markers
                if (layer instanceof ol.layer.Tile || layer instanceof ol.layer.Image) {


                    var layerNames = layer.get("name");

                    if (layerNames != "") {
                        var trobat = false;
                        var carto = {
                            'carCapas': layerNames,
                            'carNombre': 'Layer Name',
                            'carTransp': 100 - (layer.getOpacity() * 100)
                        };// config.olConfig.cartografias[j];


                        if (layer.getSource() instanceof ol.source.ImageWMS) { // singleTile == true

                            let serverUrlSource = <ol.source.ImageWMS>layer.getSource();

                            let params = serverUrlSource.getParams();
                            //Esborrat de tot el que no és necessari

                            var reqUrl = this.createWMSQuery(extent, pixWidth, pixHeight, carto, layer.getSource(), serverUrlSource.getUrl(), this.map.getView().getProjection().getCode(), 0, "");
                            //console.log("print WMS url: " + reqUrl);
                            printParams["l" + count] = reqUrl.replace("png8", "png");
                            printParams["d" + count] = carto.carNombre;
                            printParams["t" + count] = carto.carTransp;

                        } else if (layer.getSource() instanceof ol.source.TileWMS) { // singleTile == false

                            //serverUrl = layer.getSource().getUrls()[0]; // agafem només la primera url
                            let serverUrlSource = <ol.source.TileWMS>layer.getSource();
                            let params = serverUrlSource.getParams();
                            //Esborrat de tot el que no és necessari

                            var reqUrl = this.createWMSQuery(extent, pixWidth, pixHeight, carto, layer.getSource(), serverUrlSource.getUrls()[0], this.map.getView().getProjection().getCode(), 0, "");
                            //console.log("print WMS url: " + reqUrl);
                            printParams["l" + count] = reqUrl.replace("png8", "png");
                            printParams["d" + count] = carto.carNombre;
                            printParams["t" + count] = carto.carTransp;
                        }
                        count++;
                    }
                } else if (layer instanceof ol.layer.Vector && layer.get("id") === "olDrawTool") {// layer del redlining.
                    let features = layer.getSource().getFeatures();

                    if (features.length > 0) {
                        let format = new ol.format.WKT();
                        for (let indexFeatures = 0; indexFeatures < features.length; indexFeatures++) {
                            let feature = features[indexFeatures];
                            let wkt_geometry = format.writeGeometry(feature.getGeometry());
                            let wkt_feature = format.writeFeature(feature, {
                                dataProjection: "EPSG:4326",//this.map.getView().getProjection().getCode()
                                featureProjection: this.map.getView().getProjection().getCode(),
                                decimals: 10
                            });
                            console.debug("wkt_geometry", wkt_geometry);
                            console.debug("wkt_feature", wkt_feature);
                            //serialitzem estil
                            if (feature.getGeometry().getType() === "Point") {
                                let src_img = feature.get("urlImageActive");
                                printParams["l" + count] = "coord:" + ol.extent.getCenter(feature.getGeometry().getExtent()).toString();
                                printParams["s" + count] = src_img;
                                if(!src_img.includes("/assets/")){
                                    let colorText = feature.get("colorText");
                                    let textLabel = feature.get("textLabel");
                                    let lengthText = feature.get("lengthText");
                                    let atributsText = "|colorText:" + colorText + "|textLabel:" + textLabel + "|lengthText:" + lengthText;
                                    printParams["s" + count] += atributsText;
                                }                             
                                printParams["srs" + count] = this.map.getView().getProjection().getCode();
                            } else if (feature.getGeometry().getType() === "LineString") {

                                let styleContorn = "";
                                let styleLinia = "";
                                let strokeLength = Number.parseInt(feature.get("lengthStrokeLinestring") + "") + 5;
                                let lineLength = Number.parseInt(feature.get("lengthStrokeLinestring") + "");
                                let colorLinestringFill = feature.get("colorLinestringFill");
                                let colorLinestringStroke = feature.get("colorLinestringStroke");

                                styleContorn += "strokeColor:" + colorLinestringStroke + "|";
                                styleContorn += "strokeWidth:" + strokeLength + "|";
                                styleContorn += "strokeOpacity:1|";

                                styleLinia += "strokeColor:" + colorLinestringFill + "|";
                                styleLinia += "strokeWidth:" + lineLength + "|";
                                styleLinia += "strokeOpacity:1|";

                                /*if (color.indexOf("rgb") >= 0) {
                                    var splited_rgb = color.replace("rgb", "").replace("a", "").replace("(", "").replace(")", "").split(",");
                                    var red = splited_rgb[0];
                                    var green = splited_rgb[1];
                                    var blue = splited_rgb[2];
                                    color = this.rgbToHex(red, green, blue);
                                }*/

                                //contorn
                                printParams["l" + count] = "wkt:" + wkt_geometry;
                                printParams["d" + count] = "features redlining";
                                printParams["s" + count] = styleContorn;
                                printParams["t" + count] = 0;
                                printParams["srs" + count] = this.map.getView().getProjection().getCode();
                                count++;
                                //linia
                                printParams["l" + count] = "wkt:" + wkt_geometry;
                                printParams["d" + count] = "features redlining";
                                printParams["s" + count] = styleLinia;
                                printParams["t" + count] = 0;
                                printParams["srs" + count] = this.map.getView().getProjection().getCode();

                            } else {//polygon
                                let style = "";
                                let strokeLength = Number.parseInt(feature.get("lengthStrokePolygon") + "") + 5;

                                style += "strokeColor:" + feature.get("colorPolygonStroke") + "|";
                                style += "strokeWidth:" + strokeLength + "|";
                                style += "strokeOpacity:1|";

                                /*if (color.indexOf("rgb") >= 0) {
                                    var splited_rgb = color.replace("rgb", "").replace("a", "").replace("(", "").replace(")", "").split(",");
                                    var red = splited_rgb[0];
                                    var green = splited_rgb[1];
                                    var blue = splited_rgb[2];
                                    color = this.rgbToHex(red, green, blue);
                                }*/
                                style += "fillColor:" + feature.get("colorPolygonFill") + "|";
                                style += "hoverFillOpacity:0.8|";
                                style += "fillOpacity:0.4";


                                printParams["l" + count] = "wkt:" + wkt_geometry;
                                printParams["d" + count] = "features redlining";
                                printParams["s" + count] = style;
                                printParams["t" + count] = 0;
                                printParams["srs" + count] = this.map.getView().getProjection().getCode();
                            }
                            count++;
                        }//for features
                    }// if features

                } else if (layer instanceof ol.layer.Vector && layer.get("id") === "olMarkers") {// layer del redlining.
                    let features = layer.getSource().getFeatures();
                    for (let index = 0; index < features.length; index++) {
                        let geometry = features[index].getGeometry();
                        printParams["l" + count] = "coord:" + (geometry as ol.geom.Point).getCoordinates().join(",");
                        printParams["s" + count] = window.location.protocol + "//" + window.location.host + window.location.pathname + "assets/img/marker-icon2.png";
                        count++;
                    }
                } else {
                    console.warn("Layer not supportd to print.", layer);
                }
            }
        } //for layer

        this.MapService.doPrint(printParams).then((tuple: [Blob, string]) => {
            let blob: Blob = tuple[0];
            let filename: string = tuple[1];
            var fileURL = URL.createObjectURL(blob);
            
            $(`<a style="display:none" href="${fileURL}" download="${filename}" ></a>`)
                .appendTo("body")[0]
                .click();
            $("#printStateLoading").hide();
            $("#printStateFinished").show();
            setTimeout(() => {
                $("#printStateLoading").hide();
                $("#printStateFinished").hide();
            }, 10000);
        }).catch(error => {
            $("#printStateLoading").hide();
            $("#printStateFinished").hide();
        });

    }//end method


    private createWMSQuery(queryExtent, queryWidth, queryHeight, carto, layer, serverUrl, srs, angle, paramsURL): string {
        var options = {
            REQUEST: "GetMap",
            SERVICE: "WMS",
            VERSION: "1.1.1",
            STYLES: "",
            BBOX: queryExtent[0] + "," + queryExtent[1] + "," + queryExtent[2] + "," + queryExtent[3],
            WIDTH: queryWidth,
            HEIGHT: queryHeight,
            SRS: srs,
            FORMAT: "image/png",
            transparent: true,
            LAYERS: carto.carCapas/*,
                    ANGLE:angle*/
        };
        // si ens han definit un printlayers l'hem de fer servir

        if (serverUrl.indexOf("?") < 0) {
            serverUrl += "?";
        }
        let reqUrl = serverUrl + "&" + this.joinParams(options) + "&" + paramsURL;
        // var reqUrl = layer.getFullRequestString(options, serverUrl);

        return reqUrl;
    }

    private toggleGeolocation(event: boolean) {

        this.geolocationClasses.geolocation = !this.geolocationClasses.geolocation;
        this.geolocationClasses.geolocationActive = !this.geolocationClasses.geolocationActive;

        /*if (!this.geolocationClasses.geolocationActive) {//no actiu
            this.geolocation.setTracking(this.geolocationClasses.geolocationActive);
            let layer = this.getLayerByProperty("id", "olGeoposition")[0];
            this.map.removeLayer(layer);
            return;
        }*/

        this.geolocation = new ol.Geolocation({
            projection: this.map.getView().getProjection()
        });

        this.geolocation.setTracking(this.geolocationClasses.geolocationActive);

        let geolocationOnError = (event) => {
            alert(event.message);
        }

        // handle geolocation error.
        this.geolocation.on('error', geolocationOnError);

        let accuracyFeature = new ol.Feature();
        let geolocationOnChangeAccuracyGeometry = (event) => {
            accuracyFeature.setGeometry(this.geolocation.getAccuracyGeometry());
        }
        this.geolocation.on('change:accuracyGeometry', geolocationOnChangeAccuracyGeometry);

        let positionFeature = new ol.Feature();

        positionFeature.setStyle(
            [new ol.style.Style({
                image: new ol.style.Circle({
                    radius: 18,
                    fill: new ol.style.Fill({
                        color: 'rgba(51,153,204,0.34)'//rgba(51,153,204,0.34)
                    })
                })
            }), new ol.style.Style({
                image: new ol.style.Circle({
                    radius: 10,
                    fill: new ol.style.Fill({
                        color: 'rgb(23,101,244)'//#3399CC
                    }),
                    stroke: new ol.style.Stroke({
                        color: '#fff',
                        width: 2
                    })
                })
            })]
        );

        let geolocationOnChangePosition = (event) => {
            let coordinates = this.geolocation.getPosition();
            let bbox: [number, number, number, number] = [MapComponent.config.mapconfig.bbox[0], MapComponent.config.mapconfig.bbox[1],//xmin ymin
                MapComponent.config.mapconfig.bbox[2], MapComponent.config.mapconfig.bbox[3]]
            if (ol.extent.containsCoordinate(bbox, coordinates)) {
                positionFeature.setGeometry(coordinates ? new ol.geom.Point(coordinates, 'XY') : null);
                let extent = positionFeature.getGeometry().getExtent();
                this.centraAmbEfecte(extent);
            }
            else { this.mapIssues.push({ message: "Ets a fora del municipi! No mostrarem la posició." }); }

            this.geolocationClasses.geolocationActive = !this.geolocationClasses.geolocationActive;
            this.geolocationClasses.geolocation = !this.geolocationClasses.geolocation;
            this.geolocation.setTracking(this.geolocationClasses.geolocationActive);
        }

        this.geolocation.on('change:position', geolocationOnChangePosition);

        let geoPositionLayer = new ol.layer.Vector({
            source: new ol.source.Vector({
                features: [accuracyFeature, positionFeature]
            })
        });

        let properties = {
            id: "olGeoposition",
            name: "olGeoposition",
            zIndex: 1000,
            isTool: false
        };

        geoPositionLayer.setProperties(properties, true);
        this.addToolLayer(geoPositionLayer);
    }

    /*------------------ MAP UTILS ----------------*/

    private joinParams(params): string {
        var blkstr = [];

        $.each(params, function(idx2, val2) {
            var str = idx2 + "=" + val2;
            blkstr.push(str);
        });

        return blkstr.join("&");
    };
    private calculateExtentByScale(center, scale, widthPixels, heightPixels): [number, number][][] {
        var coord_min = this.getExtentPointFromPointAndScale(0, 0, center, scale, widthPixels, heightPixels);
        var coord_max = this.getExtentPointFromPointAndScale(widthPixels, heightPixels, center, scale, widthPixels, heightPixels);


        return [[[coord_min[0], coord_min[1]], [coord_min[0], coord_max[1]], [coord_max[0], coord_max[1]], [coord_max[0], coord_min[1]], [coord_min[0], coord_min[1]]]];

    }

    private getExtentFromPointAndScale = function(point, scaleDen, pixWidth, pixHeight) {

        // convert point+scale to bbox . 1cm = 37.93811pixels
        var widthMeters = pixWidth / (MapUnits.DOTS_PER_INCH * MapUnits.INCHES_PER_UNIT.m);
        var heightMeters = pixHeight / (MapUnits.DOTS_PER_INCH * MapUnits.INCHES_PER_UNIT.m);

        var coordsWidth = widthMeters * scaleDen;
        var coordX0 = parseFloat(point[0]) - coordsWidth / 2;
        var coordX1 = parseFloat(point[0]) + coordsWidth / 2;

        var coordsHeight = heightMeters * scaleDen;
        var coordY0 = parseFloat(point[1]) - coordsHeight / 2;
        var coordY1 = parseFloat(point[1]) + coordsHeight / 2;
        var theExtent = [coordX0, coordY0, coordX1, coordY1]
        return theExtent;
    };

    private getExtentPointFromPointAndScale = function(pixX, pixY, point, scaleDen, pixWidth, pixHeight): [number, number] {

        // convert point+scale to bbox . 1cm = 37.93811pixels
        var widthMeters = pixWidth / (MapUnits.DOTS_PER_INCH * MapUnits.INCHES_PER_UNIT.m);
        var heightMeters = pixHeight / (MapUnits.DOTS_PER_INCH * MapUnits.INCHES_PER_UNIT.m);

        var coordsWidth = widthMeters * scaleDen;
        var coord_x_min = parseFloat(point[0]) - coordsWidth / 2;
        var coord_x_max = parseFloat(point[0]) + coordsWidth / 2;

        var coordsHeight = heightMeters * scaleDen;
        var coord_y_min = parseFloat(point[1]) - coordsHeight / 2;
        var coord_y_max = parseFloat(point[1]) + coordsHeight / 2;


        var centerX = coord_x_min + (pixX / pixWidth) * coordsWidth;
        var centerY = coord_y_max - (pixY / pixHeight) * coordsHeight;

        return [centerX, centerY];

    };

    private getLayerByProperty(property, value): any[] {

        console.debug(">>> Map.Component - getLayerByProperty. Num layers -> " + this.map.getLayers().getArray().length);
        for (var index = 0; index < this.map.getLayers().getArray().length; index++) {
            var layer = this.map.getLayers().getArray()[index];
            console.debug("index: " + index + " -> layer property value " + layer.get(property) + " - value searched " + value);
            if (typeof (layer.get(property)) !== "undefined" && layer.get(property) === value) {
                return [layer];
            }
        }
        return [];
    }

    /**
     * Function: normalizeScale
     *
     * Parameters:
     * scale - {float}
     *
     * Returns:
     * {Float} A normalized scale value, in 1 / X format.
     *         This means that if a value less than one ( already 1/x) is passed
     *         in, it just returns scale directly. Otherwise, it returns
     *         1 / scale
     */
    private normalizeScale(scale: number): number {
        console.debug(">>> Map.Component - normalizeScale");
        let normScale = (scale > 1.0) ? (1.0 / scale)
            : scale;
        return normScale;
    };

    /**
     * Function: getResolutionFromScale
     *
     * Parameters:
     * scale - {Float}
     * units - {String} Index into OpenLayers.INCHES_PER_UNIT hashtable.
     *                  Default is degrees
     *
     * Returns:
     * {Float} The corresponding resolution given passed-in scale and unit
     *     parameters.  If the given scale is falsey, the returned resolution will
     *     be undefined.
     */
    private getResolutionFromScale(scale: number, units: string): number {
        console.debug(">>> Map.Component - getResolutionFromScale");
        let resolution;
        if (scale) {
            if (units == null) {
                units = "degrees";
            }
            var normScale = this.normalizeScale(scale);
            resolution = 1 / (normScale * MapUnits.INCHES_PER_UNIT[units] * MapUnits.DOTS_PER_INCH);
        }
        return resolution;
    }

    /**
    * Function: getScaleFromResolution
    *
    * Parameters:
    * scale - {Float}
    * units - {String} Index into OpenLayers.INCHES_PER_UNIT hashtable.
    *                  Default is degrees
    *
    * Returns:
    * {Float} The corresponding resolution given passed-in scale and unit
    *     parameters.  If the given scale is falsey, the returned resolution will
    *     be undefined.
    */
    private getScaleFromResolution(resolution: number, units: string): number {
        console.debug(">>> Map.Component - getScaleFromResolution");
        if (resolution) {
            if (units == null) {
                units = "degrees";
            }
            return Math.round(MapUnits.DOTS_PER_INCH * resolution * MapUnits.INCHES_PER_UNIT[units]);
        }
        return -1;
    }

    /**
    * Converteix les escales de la configuració a resolucions.
    */
    private getResolutions(): number[] {
        console.debug(">>> Map.Component - getResolutions");
        let result = [];
        let scales = MapComponent.config.mapconfig.scales;
        if (scales.length > 0) {
            for (let i = 0; i < scales.length; i++) {
                let scale = scales[i];
                let resolution = this.getResolutionFromScale(scale, 'm');
                result.push(resolution)
            }
        }
        return result;
    }

    private getFeatureInfoExtent(center): [number, number, number, number] {
        //console.group("MapComponent UTILS -> getFeatureInfoExtent");
        //console.debug("centre:", center);
        let viewResolution = this.map.getView().getResolution();
        let viewRotation = this.map.getView().getRotation();
        let size = GETFEATUREINFO_IMAGE_SIZE_DEFAULT;

        //console.debug("center provided:", center);

        let dx = viewResolution * size[0] / 2;
        let dy = viewResolution * size[1] / 2;

        let cosRotation = Math.cos(viewRotation);
        let sinRotation = Math.sin(viewRotation);

        let xCos = dx * cosRotation;
        let xSin = dx * sinRotation;
        let yCos = dy * cosRotation;
        let ySin = dy * sinRotation;

        let x = center[0];
        let y = center[1];

        let x0 = x - xCos + ySin;
        let x1 = x - xCos - ySin;
        let x2 = x + xCos - ySin;
        let x3 = x + xCos + ySin;

        let y0 = y - xSin - yCos;
        let y1 = y - xSin + yCos;
        let y2 = y + xSin + yCos;
        let y3 = y + xSin - yCos;

        let minX = Math.min(x0, x1, x2, x3);
        let minY = Math.min(y0, y1, y2, y3);
        let maxX = Math.max(x0, x1, x2, x3);
        let maxY = Math.max(y0, y1, y2, y3);

        //console.debug("extend obtained:", [minX, minY, maxX, maxY]);
        console.groupEnd();
        return [minX, minY, maxX, maxY];
    }

    private centraAmbEfecte(extent: [number, number, number, number]): void {
        this.map.getView().fit(extent, { duration: 1000 });
    }
    private raiseLayerOrder(layer) {
        //map.addLayer(layer);
        var overlayLayers = this.map.getLayers().getArray();//map.getLayersBy("CLASS_NAME","OpenLayers.Layer.WMS");
        // recorremos los layers mirando su orden para calcular la posición donde tiene que ir
        var len = overlayLayers.length;
        if (len > 0) {
            for (var i = 0, layerS; layerS = overlayLayers[i]; i++) {

                var layer1 = parseInt(layerS.get("zIndex"));
                var layer2 = parseInt(layer.get("zIndex"));

                if (layer2 <= layer1) {
                    this.map.getLayers().insertAt(i, layer);
                    break;
                }
            }
            if (this.map.getLayers().getArray().length === len) {
                this.map.getLayers().insertAt(len, layer);
            }
        }
        else {
            this.map.getLayers().insertAt(len, layer);
        }
    }
    private browserHasLocation(): boolean {
        return window.isSecureContext;
    }

    @HostListener("document:hl-layer", ['$event'])
    public highlightLayerHandler(event) {
        this.hlLayersService.highlightLayerHandler(this.map, event);
    }

    @HostListener("document:hl-layer-reset", ['$event'])
    public highlightLayerResetHandler(event) {
        this.hlLayersService.highlightLayerResetHandler(this.map, event);
    }


}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/map/map.component.ts